import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Typography,
} from "@material-ui/core";
import React from "react";

import CloseIcon from "@material-ui/icons/Close";

import { Alert } from "@material-ui/lab";

import { useModalStyles } from "../../../../EventsPage";

export const RemoveEventsModal: React.FC<{
  numSelectedEvents: number;
  onClose: () => void;
  onSave: () => void;
}> = ({ numSelectedEvents, onClose, onSave }) => {
  const classes = useModalStyles();

  return (
    <Modal open={true} onClose={onClose} title="Confirm Event Deletion">
      <Card className={classes.root}>
        <CardHeader
          title="Confirm Event Deletion"
          classes={{ action: classes.closeIconAction }}
          action={<CloseIcon onClick={onClose} />}
        />

        <Divider />

        <CardContent>
          <Alert severity="error" style={{ marginBottom: "1em" }}>
            <Typography variant="body1">
              Warning: This operation will completely delete{" "}
              {numSelectedEvents > 1
                ? `all ${numSelectedEvents} selected event definitions`
                : "this event definition"}
              .
            </Typography>
          </Alert>

          <Typography variant="body1" style={{ marginBottom: "1em" }}>
            Removing these event definitions means that event data will no
            longer be sent to any destinations, and any dynamic properties
            defined on these events will no longer be computed or captured in
            data collected by Freshpaint.
          </Typography>

          <Typography variant="body1" style={{ marginBottom: "1em" }}>
            If you'd simply like to stop events from going to a destination, use
            the "Edit Destinations" button instead.
          </Typography>

          <Typography>
            <strong>
              Are you sure you want to delete {numSelectedEvents} event
              {numSelectedEvents > 1 && "s"}?
            </strong>
          </Typography>
        </CardContent>

        <Divider />

        <CardActions className={classes.actions}>
          <Button onClick={onClose} variant="contained">
            Cancel
          </Button>

          <Button
            className={classes.deactivateButton}
            variant="contained"
            onClick={onSave}
          >
            Confirm
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};
